import {AxiosInstance, AxiosRequestConfig, AxiosResponse} from 'axios';
import {setCacheVersion} from './websocket'

export default class CacheControl {
  private static instance: CacheControl;

  static getInstance() {
    if (!this.instance) {
      this.instance = new CacheControl();
    }
    return this.instance;
  }

  register(api: AxiosInstance) {
    api.interceptors.request.use(this.interceptRequest.bind(this));
    api.interceptors.response.use(this.interceptResponse.bind(this));
  }

  private static getCacheableResources() {
    let cacheableResources: Map<string, number>;
    try {
      cacheableResources = new Map(JSON.parse(localStorage.getItem('http-cacheable-resources') || '[]'));
    } catch (e) {
      cacheableResources = new Map();
    }

    const now = Date.now();
    for(const [resource, expiry] of cacheableResources.entries()){
      if(now > expiry){
        cacheableResources.delete(resource);
      }
    }

    return cacheableResources;
  }

  private static addCacheableResource(resource: string, maxAge: number) {
    const cacheableResources = CacheControl.getCacheableResources();
    cacheableResources.set(resource, maxAge > 0 ? (Date.now() + (maxAge * 1000)) : maxAge);
    localStorage.setItem('http-cacheable-resources', JSON.stringify(Array.from(cacheableResources.entries())));
    return cacheableResources;
  }

  private static isCacheableResource(resource: string) {
    return CacheControl.getCacheableResources().has(resource);
  }

  interceptRequest(config: AxiosRequestConfig) {
    if (config.method.toUpperCase() === 'GET') {
      if (CacheControl.isCacheableResource(config.url)) {
        let cacheVersion = localStorage.getItem('http-cache-version');
        if (!cacheVersion) cacheVersion = setCacheVersion(`${Date.now()}`);

        if (!config.params) config.params = {};
        config.params['cacheVersion'] = cacheVersion;
      }else {
        config.headers['Cache-Control'] = 'no-cache';
        config.headers['Pragma'] = 'no-cache';
        config.headers['Expires'] = '0';
      }
    } else {
      setCacheVersion(`${Date.now()}`);
    }
    return config;
  }

  interceptResponse(response: AxiosResponse) {
    const cacheControl = response.headers['cache-control'];
    if (cacheControl && !cacheControl.includes('no-cache') && !cacheControl.includes('no-store')) {
      let [, maxAge] = cacheControl.match(/max-age=(\d+)/);
      maxAge = maxAge ? parseInt(maxAge) : -1;
      CacheControl.addCacheableResource(response.config.url, maxAge);
    }
    return Promise.resolve(response);
  }
}
